module.exports = __webpack_public_path__ + "static/media/nf.44fe5947.svg";